import CONSTANTS from './product/CONSTANTS';

import { formatMoney } from '@shopify/theme-currency';
import axiosGetFullProductJSON from './product/axiosGetFullProductJSON';
import getCurrentSelectedOptions from './product/getCurrentSelectedOptions';
import getSizedImage from './product/getSizedImage';
import getVariantById from './product/getVariantById';
import getVariantFromVariantsAndOptions from './product/getVariantFromVariantsAndOptions';
import getVariantImageUrl from './product/getVariantImageUrl';
import switchStockDisplay from './product/switchStockDisplay';
import updatePrice from './product/updatePrice';
import updateVariantFormField from './product/updateVariantFormField';
import updateVariantUrl from './product/updateVariantUrl';
import quickOrderListForm from './products/quickOrderListForm';

const defaults = CONSTANTS;

/**
 *
 * option defaults from contants:
 * product_form_selector: "[data-product-form-pdp]"
 * product_option_select_selector: "[data-option-select]"
 * product_main_image_selector: "[data-main-product-image]"
 * product_variant_id_form_field: "[data-product-form] [name="id"]"
 * product_image_thumbs_selector: "[data-product-thumbnail-index]"
 * product_image_thumbs_attr: "data-product-thumbnail-index"
 * product_thumbnail_active_class: "active"
 * product_stock_wrapper_attr: "data-product-in-stock"
 * product_oos_text_attr: "data-oos-text"
 * product_in_stock_text_attr: "data-in-stock-text"
 * product_unavailable_text_attr: "data-unavailable-text"
 * product_form_submit_button_selector: "[data-product-form-submit]"
 * product_price_selector: "[data-product-price]"
 * product_compare_at_price_selector: "[data-product-compare-at-price]"
 */

export const productInit = async (options, productUpdatedCallBack = variant => variant) => {
  const opts = Object.assign({}, defaults, options);

  const productForms = document.querySelectorAll(opts.product_form_selector);

  if (productForms.length === 0) {
    quickOrderListForm();

    return false;
  }

  // Voyado TODO
  // We need to query Voyado here and generate the ticket

  for (const [index, productForm] of productForms.entries()) {
    //get the data
    const getThisProductsJSON = axiosGetFullProductJSON(productForm.dataset.productForm);
    const productData = await getThisProductsJSON();
    //get all the elements
    const variantIdFormField = productForm.querySelector(opts.product_variant_id_form_field);
    const atcButton = document.querySelector(opts.product_form_submit_button_selector);
    const dummyAtcButton = document.querySelector(opts.product_form_dummy_button_selector);
    const priceEls = productForm.querySelectorAll(opts.product_price_selector);
    const compareAtpriceEls = productForm.querySelectorAll(opts.product_compare_at_price_selector);
    const optionSelects = productForm.querySelectorAll(opts.product_option_select_selector);
    const stockMap = JSON.parse(productForm.getAttribute(opts.product_stock_map));
    const mainImage = document.querySelector(opts.product_main_image_selector);
    // const lowStockLimit = parseInt(productForm.dataset.lowStockLimit);

    const updateProductVariantFormField = updateVariantFormField(productForm, variantIdFormField);
    const updateProductPrice = updatePrice(priceEls, compareAtpriceEls, window.theme.moneyFormat);

    // document.querySelectorAll()

    const switchProductStockDisplay = switchStockDisplay({
      stockWrapper: productForm,
      stockWrapperAttr: opts.product_stock_wrapper_attr,
      atcButton,
      dummyAtcButton,
      oosAttr: opts.product_oos_text_attr,
      inStockAttr: opts.product_in_stock_text_attr,
      unavailableAttr: opts.product_unavailable_text_attr,
      preOrderAttr: opts.product_pre_order_attr,
      comingSoonAttr: opts.product_coming_soon_attr
    });

    const getAvailabilityFlag = variant =>
      variant && stockMap[variant.id.toString()] ? stockMap[variant.id.toString()]['availability'] : 'unavailable';
    // const getVariantQty = variant =>
    //   variant && stockMap[variant.id.toString()] ? stockMap[variant.id.toString()]['qty'] : '0';
    // const getSellingPlanId = variant =>
    //   variant && stockMap[variant.id.toString()] ? stockMap[variant.id.toString()]['selling_plan_id'] : null;

    const updateStockDisplay = variant => {
      const flag = getAvailabilityFlag(variant);
      switchProductStockDisplay(flag, false);
    };

    const updateVariantData = variant => {
      let unselectedOptions = 0;

      document.querySelectorAll(opts.product_option_select_selector).forEach(activeSelect => {
        if (activeSelect.value === 'Please Select') unselectedOptions++;
      });

      if (unselectedOptions === 2) {
        updateStockDisplay('');
      } else if (variant) {
        updateStockDisplay(variant);
      }

      updateVariantUrl(variant);
      updateProductPrice(variant);
      updateProductVariantFormField(variant);
      productUpdatedCallBack(variant, productData);
    };

    const getQueryVariable = variable => {
      const query = window.location.search.substring(1);
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return false;
    };

    const removePreselectedVariant = () => {
      // Removes checked radios
      const allVariantsOptions = document.querySelectorAll('[data-option-select]');

      if (allVariantsOptions.length > 1) {
        allVariantsOptions.forEach(el => {
          el.removeAttribute('checked');
        });
        // Removes value from ID so nothing gets added to cart
        document.querySelectorAll('[name="id"]').forEach(atcId => {
          atcId.removeAttribute('value');
        });
        // Hides stock option
        document.querySelectorAll('.variant-option__stock').forEach(stockOption => {
          stockOption.classList.add('hide');
        });
        // Disables ATC button
        atcButton.setAttribute('disabled', 'disabled');
        atcButton.innerHTML = atcButton.getAttribute('data-default-text');
      }
    };

    const pageVariantSelected = getQueryVariable('variant');

    if (pageVariantSelected) {
      const variant = getVariantById(productData.variants, parseInt(pageVariantSelected));
      updateVariantData(variant);
    } else {
      removePreselectedVariant();
    }

    const highlightStockOptions = () => {
      const oosVariantList = [];
      const preOrderVariantsList = [];
      const comingSoonVariantsList = [];
      const lowStockVariantsList = [];

      productData.variants.forEach(variant => {
        const availability = getAvailabilityFlag(variant);
        if (availability === 'low') {
          lowStockVariantsList.push(variant.title);
        }
        if (availability === 'pre-order') {
          preOrderVariantsList.push(variant.title);
        }
        if (availability === 'coming-soon') {
          comingSoonVariantsList.push(variant.title);
        }
        if (availability === 'oos') {
          oosVariantList.push(variant.title);
        }
      });

      const lowStockVariants = Array.from(optionSelects).filter(option =>
        lowStockVariantsList.includes(option.dataset.optionLabel)
      );
      const preOrderVariants = Array.from(optionSelects).filter(option =>
        preOrderVariantsList.includes(option.dataset.optionLabel)
      );
      const comingSoonVariants = Array.from(optionSelects).filter(option =>
        comingSoonVariantsList.includes(option.dataset.optionLabel)
      );
      const oosVariants = Array.from(optionSelects).filter(option =>
        oosVariantList.includes(option.dataset.optionLabel)
      );

      lowStockVariants.forEach(variant => variant.parentElement.classList.add('variant-option__option--low-stock'));
      preOrderVariants.forEach(variant => variant.parentElement.classList.add('variant-option__option--pre-order'));
      comingSoonVariants.forEach(variant => variant.parentElement.classList.add('variant-option__option--coming-soon'));
      oosVariants.forEach(variant => variant.parentElement.classList.add('variant-option__option--oos'));
    };

    highlightStockOptions();

    const recalcCoordTotals = (selects, event) => {
      const currentOptions = getCurrentSelectedOptions(selects);
      const variant = getVariantFromVariantsAndOptions(productData.variants)(currentOptions);
      updateVariantData(variant);

      const coordCountElem = document.querySelector('[data-co-ord-item-count]');
      const coordTotalElem = document.querySelector('[data-co-ord-item-price]');

      if (coordCountElem && coordTotalElem) {
        let totalPrice = 0,
          itemCount = 0,
          validSelectableCount = 0;

        const coordItems = document.querySelectorAll('.product-co-ord');
        coordItems.forEach(item => {
          const include = item.querySelector('[data-co-ord-include]');
          if (include && include.checked) {
            const selectedOption = item.querySelector('[data-co-ord-form-wrapper] [data-option-select]:checked');
            if (selectedOption) {
              const price = parseFloat(selectedOption.dataset.optionPrice);
              if (!isNaN(price) && price > 0) {
                totalPrice += price;
              }
              itemCount++;
              validSelectableCount++;
            }
          }
        });

        // as you can now select the variants (even when OOS - for BIS puproses)
        // ensure that if at least 1 itemCount (price is 0 on OOS)
        // that the button is purchasable
        if (atcButton) {
          if (validSelectableCount > 0) {
            atcButton.removeAttribute('disabled');
            atcButton.innerHTML = atcButton.getAttribute('data-in-stock-text');
          } else {
            atcButton.setAttribute('disabled', 'disabled');
            atcButton.innerHTML = atcButton.getAttribute('data-default-text');
          }
        }

        coordCountElem.innerHTML = itemCount;
        coordTotalElem.innerHTML = '';
        if (totalPrice > 0) coordTotalElem.innerHTML = formatMoney(totalPrice, window.theme.moneyFormat);

        if (event && event?.target) {
          const selectFormWrapper = event.target.closest('[data-product-form]');
          const bisFormWrapper = selectFormWrapper.querySelector('[data-back-in-stock]');
          if (bisFormWrapper) {
            const bisForm = bisFormWrapper.querySelector('[data-bis-form]');
            const bisMessages = bisFormWrapper.querySelector('[data-notify-message]');
            bisMessages.classList.add('hide');
            if (event?.target?.value === 'Please Select') {
              bisForm.classList.add('hide');
            } else {
              bisForm.classList.remove('hide');
            }
          }
        }
      }
      try {
        if (variant) {
          const fetchCompleteProductData = async () => {
            try {
              const response = await fetch(`/products/${productForm.dataset.productForm}.js`);
              const completeProductData = await response.json();
              const completeVariant = completeProductData.variants.find(v => v.id === variant.id);

              if (completeVariant) {
                let targetSlideIndex = null;
                const imagesSwiper =
                  window.blubolt && window.blubolt.swiperObjects
                    ? window.blubolt.swiperObjects.find(
                      sw => sw && sw.el && sw.el.getAttribute('id') === 'product-media__images'
                    )
                    : null;
                const thumbsSwiper =
                  window.blubolt && window.blubolt.swiperObjects
                    ? window.blubolt.swiperObjects.find(
                      sw => sw && sw.el && sw.el.getAttribute('id') === 'product-media__thumbs'
                    )
                    : null;

                if (completeVariant?.featured_media?.id) {
                  const mediaId = completeVariant.featured_media.id;
                  if (imagesSwiper && imagesSwiper.slides && imagesSwiper.slides.length) {
                    for (let i = 0; i < imagesSwiper.slides.length; i++) {
                      const slide = imagesSwiper.slides[i];
                      const slideImg = slide.querySelector('img');
                      if (slideImg && slideImg.dataset.mediaId === mediaId.toString()) {
                        targetSlideIndex = i;
                        break;
                      }
                    }
                  }
                }

                if (targetSlideIndex === null && completeVariant?.featured_image?.src) {
                  const variantImageUrl = completeVariant.featured_image.src;

                  if (imagesSwiper && imagesSwiper.slides && imagesSwiper.slides.length) {
                    for (let i = 0; i < imagesSwiper.slides.length; i++) {
                      const slide = imagesSwiper.slides[i];
                      const slideImg = slide.querySelector('img');
                      if (slideImg) {
                        const slideSrc = slideImg.currentSrc || slideImg.src || '';
                        // Compare image URLs (strip query params for comparison)
                        if (slideSrc.split('?')[0] === variantImageUrl.split('?')[0]) {
                          targetSlideIndex = i;
                          break;
                        }
                      }
                    }
                  }
                }

                if (targetSlideIndex !== null) {
                  if (imagesSwiper && imagesSwiper.slides && imagesSwiper.slides.length) {
                    if (targetSlideIndex >= 0 && targetSlideIndex < imagesSwiper.slides.length) {
                      if (typeof imagesSwiper.slideToLoop === 'function') {
                        imagesSwiper.slideToLoop(targetSlideIndex);
                      } else {
                        imagesSwiper.slideTo(targetSlideIndex);
                      }

                      if (thumbsSwiper && thumbsSwiper.slides && thumbsSwiper.slides.length) {
                        if (typeof thumbsSwiper.slideToLoop === 'function') {
                          thumbsSwiper.slideToLoop(targetSlideIndex);
                        } else {
                          thumbsSwiper.slideTo(targetSlideIndex);
                        }
                      }
                    }
                  }
                }
              }
            } catch (fetchError) {
              console.error('Error fetching complete product data:', fetchError);
            }
          };
          fetchCompleteProductData();
        }
      } catch (e) {
        console.error('Error in recalcCoordTotals:', e);
      }

      return variant;
    };

    const onSelectChange = selects => event => {
      const variant = recalcCoordTotals(selects, event);

      // If the interaction happened within a co-ord item, auto-toggle its include checkbox
      if (event && event.target) {
        const coordItem = event.target.closest('.product-co-ord');
        if (coordItem) {
          const include = coordItem.querySelector('[data-co-ord-include]');
          // Determine if a concrete size was selected
          const value = event.target.value;
          const isConcreteSize = value && value !== 'Please Select';
          if (include) {
            if (isConcreteSize) {
              include.checked = true;
            } else {
              // If reverted to placeholder, uncheck
              include.checked = false;
            }
          }
          recalcCoordTotals(selects);
        }
      }

      if (!variant || !mainImage.dataset.giftCardImage) {
        return;
      }
      const imageUrl = getVariantImageUrl(variant);
      if (!imageUrl) {
        return;
      }
      const sizedImage = getSizedImage(imageUrl, opts.IMAGE_SIZE);
      mainImage.dataset.rawSrc = imageUrl;
      mainImage.src = sizedImage;
      document.querySelector('[data-property-gift-card-image]').value = sizedImage;
    };

    [...optionSelects].forEach(select => select.addEventListener('change', onSelectChange([...optionSelects])));

    // Recalculate totals when co-ord include checkboxes change
    document.querySelectorAll('[data-co-ord-include]').forEach(cb => {
      cb.addEventListener('change', () => recalcCoordTotals([...optionSelects]));
    });

    // Wire size dropdown (if present) to hidden radio inputs for compatibility
    const sizeDropdown = productForm.querySelector('[data-size-dropdown]');
    if (sizeDropdown) {
      const syncDropdownToRadios = () => {
        const value = sizeDropdown.value;
        const radios = productForm.querySelectorAll(
          'input[data-option-select][type="radio"][name="Size"], input[data-option-select][type="radio"][name="size"]'
        );
        radios.forEach(r => {
          if (r.value === value) {
            r.checked = true;
          } else if (value === 'Please Select') {
            r.checked = false;
          }
        });
        // Auto toggle include for co-ord item based on selection
        const coordItem = sizeDropdown.closest('.product-co-ord');
        if (coordItem) {
          const include = coordItem.querySelector('[data-co-ord-include]');
          if (include) {
            include.checked = value !== 'Please Select';
          }
        }
        // Trigger variant update and totals
        onSelectChange([...optionSelects])({ target: sizeDropdown });
      };

      // Initialize dropdown selection based on any pre-checked radio
      const preChecked = productForm.querySelector(
        'input[data-option-select][type="radio"][name="Size"]:checked, input[data-option-select][type="radio"][name="size"]:checked'
      );
      if (preChecked) {
        sizeDropdown.value = preChecked.value;
      }

      sizeDropdown.addEventListener('change', syncDropdownToRadios);
    }

    onSelectChange([...optionSelects])();

    dummyAtcButton?.addEventListener('click', () => {
      console.info('Dummy ATC Click');
      if (atcButton.disabled) {
        const variantOptions = document.querySelector('[data-variant-option]');
        if (variantOptions) {
          variantOptions.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      atcButton.click();
    });

    ['load', 'resize'].forEach(function (e) {
      window.addEventListener(e, () => {
        setTimeout(() => {
          const imagesCarousel = document.querySelector('.product-media__images .swiper');
          if (imagesCarousel) {
            const imagesFirstSlide = imagesCarousel.querySelector('.swiper-slide img');
            const thumbsCarousel = document.querySelector('.product-media__thumbs .swiper');
            if (imagesFirstSlide && thumbsCarousel) {
              const thumbSlides = thumbsCarousel.querySelectorAll('.swiper-slide');
              const gap = 8; // or get from Swiper config if dynamic

              if (thumbSlides.length > 0) {
                // Assume all thumbs are the same height as the first
                const thumbHeight = thumbSlides[0].getBoundingClientRect().height;
                const mainImageHeight = imagesFirstSlide.clientHeight;

                // Calculate how many full thumbs fit
                const maxThumbs = Math.floor(mainImageHeight / (thumbHeight + gap));
                // Calculate the max height to show only full images (no partials)
                const maxThumbsHeight = maxThumbs > 0 ? maxThumbs * thumbHeight + (maxThumbs - 1) * gap : 0;

                thumbsCarousel.style.maxHeight = `${maxThumbsHeight}px`;
              }
            }
          }
        }, 100);
      });
    });

    document.querySelector('body').addEventListener('click', e => {
      const target = e.target;

      if (target.closest('[data-product-switcher]')) return;

      document.querySelectorAll('[data-product-switcher]').forEach(switcher => {
        switcher.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        switcher.classList.remove('product-detail__switcher-select--active');
      });
    });
  }
};
